import { render, staticRenderFns } from "./footerBot.vue?vue&type=template&id=ca6f6d94&scoped=true"
import script from "./footerBot.vue?vue&type=script&lang=js"
export * from "./footerBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6f6d94",
  null
  
)

export default component.exports